import { useQuery} from 'react-query'
import { getResultsRSC } from "data/Querys"
import Loader from 'components/general/Loader'
import NotAvailable from "components/common/NotAvailable";
import Results from '../events/boulder/Results';

const ClbBoulderBoulder = ({mirs_competition, mirs_rsc, mirs_language, breakPoint}) => {

    const { data, isError, isLoading } = useQuery(
        {
          queryKey: ['resultsData', mirs_competition, mirs_rsc, mirs_language],
          queryFn: getResultsRSC,
          refetchInterval: 5000,
          staleTime: 5000,
          refetchIntervalInBackground: true,
          notifyOnChangeProps: ['data', 'error'],
          //enabled: !!confCategory
          onError: (error) =>
            console.error(`Something went wrong: ${error.message}`),
        }
    )

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }
    if (!data?.results) { return <NotAvailable /> }

    return <>
        <Results data={data} mirs_competition={mirs_competition} mirs_language={mirs_language} mirs_rsc={mirs_rsc} breakPoint={breakPoint} />
    </>
}

export default ClbBoulderBoulder;